import type { Unit } from "@/api/units";
import type { UserRole } from "@/store/session";

export type ApprovalLensMode = "daily" | "weekly";

export function approvalUnitsInScope(
  units: Unit[],
  role: UserRole | undefined,
  actingUnitIds: number[] | undefined,
): Unit[] {
  if (role === "admin") return units;
  if (role === undefined) return [];
  const acting = new Set(actingUnitIds ?? []);
  return units.filter((unit) => unit.id != null && acting.has(unit.id));
}

export function approvalUnitsForMode(units: Unit[], mode: ApprovalLensMode): Unit[] {
  return units.filter((unit) => unit.approval_mode === mode);
}

interface ApprovalUnitSelectionOptions {
  units: Unit[];
  role: UserRole | undefined;
  selectedUnitId: number | null;
  ready: boolean;
}

interface ApprovalUnitSelection {
  effectiveUnitId: number | null;
  needsUnit: boolean;
  queriesEnabled: boolean;
  showPicker: boolean;
  nextUrlUnitId: number | null | undefined;
}

export function resolveApprovalUnitSelection({
  units,
  role,
  selectedUnitId,
  ready,
}: ApprovalUnitSelectionOptions): ApprovalUnitSelection {
  const selectedIsValid =
    selectedUnitId !== null && units.some((unit) => unit.id === selectedUnitId);
  const soleUnitId =
    role !== "admin" && selectedUnitId === null && units.length === 1
      ? (units[0].id ?? null)
      : null;
  const effectiveUnitId = selectedIsValid ? selectedUnitId : soleUnitId;
  const nextUrlUnitId =
    selectedUnitId !== null && !selectedIsValid
      ? null
      : selectedUnitId === null && soleUnitId !== null
        ? soleUnitId
        : undefined;
  return {
    effectiveUnitId,
    needsUnit: ready && effectiveUnitId === null,
    queriesEnabled: ready && effectiveUnitId !== null,
    showPicker: role === "admin" || units.length > 1,
    nextUrlUnitId: ready ? nextUrlUnitId : undefined,
  };
}
